import React, { useState } from 'react';
import ListTeams from './ListTeams.js';
import AddTeam from './AddTeam.js';
import Upload from '../../shared/Upload.js';
import { ListButton, AddButton, UploadButton, DownloadButton, FAB } from '../../shared/ActionButtons';

export const Teams = ({ screen, setScreen, hideHeader }) => {
  const [localScreen, setLocalScreen] = useState("list");

  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  return (
    <>
      {!hideHeader && (
        <div className="content-header">
          <div className="action-buttons">
            <ListButton
              isActive={currentScreen === "list"}
              onClick={() => setCurrentScreen("list")}
            />
            <AddButton
              isActive={currentScreen === "add"}
              onClick={() => setCurrentScreen("add")}
            />
            <UploadButton
              isActive={currentScreen === "upload"}
              onClick={() => setCurrentScreen("upload")}
            />
            <DownloadButton collection="teams"/>
          </div>
        </div>
      )}

      {currentScreen === "list" && <ListTeams/>}
      {currentScreen === "list" && <FAB onClick={() => setCurrentScreen("add")} />}
      {currentScreen === "add" && <AddTeam onSuccess={() => setCurrentScreen("list")} />}
      {currentScreen === "upload" && <Upload collection="teams" onSuccess={() => setCurrentScreen("list")} />}
    </>
  );
}

// Action buttons component for use in hub header
export const TeamsActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton
      isActive={screen === "list"}
      onClick={() => setScreen("list")}
    />
    <AddButton
      isActive={screen === "add"}
      onClick={() => setScreen("add")}
    />
    <UploadButton
      isActive={screen === "upload"}
      onClick={() => setScreen("upload")}
    />
    <DownloadButton collection="teams"/>
  </div>
);

export default Teams;
